export * from './notification.component';



// WEBPACK FOOTER //
// ./src/app/shared/notification/index.ts